export default __webpack_public_path__ + "static/media/PA.6ed44bad.ico";